import React from 'react';
import moment from 'moment';

export default class TimeInput extends React.Component {
    constructor(props) {
        super(props);
    }

    handleOnChange(event) {
        var newDate = moment(this.props.value.format("YYYY-MM-DD") + " " + event.target.value);

        this.props.onChange(newDate);
    }

    render() {
        const { value } = this.props;

        return (
    		<div>
                <input
                    className="b3-input b3-time"
                    type="time"
                    step={this.props.step}
                    onChange={ this.handleOnChange.bind(this) }
                    onFocus={this.props.onFocus}
                    onBlur={this.props.onBlur}
                    value={ value.format("HH:mm") } />
            </div>
        );
    }
}

TimeInput.defaultProps = {
    value : moment(),
    onChange: function() {},
    onFocus: function() {},
    onBlur: function() {},
    step: 60
};


// WEBPACK FOOTER //
// ./app/b3/inputs/TimeInput.js